import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/global.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const [activeHash, setActiveHash] = useState('');

  // Handle scroll events
  useEffect(() => {
    const handleScroll = () => {
      // Update navbar style on scroll
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
      
      // Only update active section based on scroll if we're on the homepage
      if (location.pathname === '/') {
        // Check for section visibility to highlight nav items
        const sections = ['hardware', 'products', 'contact'];
        let currentSection = '';
        
        for (const section of sections) {
          const element = document.getElementById(section);
          if (element) {
            const rect = element.getBoundingClientRect();
            // If the section is in view
            if (rect.top <= 150 && rect.bottom >= 150) {
              currentSection = `#${section}`;
              break;
            }
          }
        }
        
        if (currentSection) {
          setActiveHash(currentSection);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]);

  // Handle navigation with hash
  useEffect(() => {
    // If we have a hash in the URL, we should highlight the corresponding tab
    if (location.hash) {
      setActiveHash(location.hash);
      
      // If there's a hash in the URL, scroll to that element after a small delay
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({behavior: 'smooth'});
        }
      }, 100);
    } else if (location.pathname === '/') {
      // On homepage with no hash, check visible sections
      const handleScroll = () => {
        const sections = ['hardware', 'products', 'contact'];
        let currentSection = '';
        
        for (const section of sections) {
          const element = document.getElementById(section);
          if (element) {
            const rect = element.getBoundingClientRect();
            // If the section is in view
            if (rect.top <= 150 && rect.bottom >= 150) {
              currentSection = `#${section}`;
              break;
            }
          }
        }
        
        if (currentSection) {
          setActiveHash(currentSection);
        }
      };
      
      // Call it once immediately
      handleScroll();
    } else {
      // Reset scroll position when navigating to a new page without hash
      window.scrollTo(0, 0);
    }
  }, [location]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/omega-logo.png" alt="Omega Ops Cybernetics Defence Corp." className="logo" />
          <span className="company-name">Omega Ops Cybernetics Defence Corp.</span>
        </Link>
        
        <div className="tagline">
          <em>Secure. Military-Grade. Resolute.</em>
        </div>

        <div className="menu-icon" onClick={toggleMenu}>
          <span className={`hamburger ${menuOpen ? 'open' : ''}`}></span>
        </div>

        <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' && !activeHash ? 'active' : ''}`} 
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/#hardware" 
              className={`nav-link ${location.pathname === '/' && activeHash === '#hardware' || location.hash === '#hardware' ? 'active' : ''}`} 
              onClick={() => setMenuOpen(false)}
            >
              Hardware
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/#products" 
              className={`nav-link ${location.pathname === '/' && activeHash === '#products' || location.hash === '#products' ? 'active' : ''}`} 
              onClick={() => setMenuOpen(false)}
            >
              Products
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/#contact" 
              className={`nav-link ${location.pathname === '/' && activeHash === '#contact' || location.hash === '#contact' ? 'active' : ''}`} 
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/privacy" 
              className={`nav-link ${location.pathname === '/privacy' ? 'active' : ''}`} 
              onClick={() => setMenuOpen(false)}
            >
              Privacy
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/terms" 
              className={`nav-link ${location.pathname === '/terms' ? 'active' : ''}`} 
              onClick={() => setMenuOpen(false)}
            >
              Terms
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;